import { Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivityRelationUpdateModel } from '@app/modules/activity-relation/models/activity-relation-update.model';
import { ParticipantStatus, ParticipantStatusLabels } from '@app/modules/activity/enums/participant-status.enum';
import { PaymentStatus, PaymentStatusIcons } from '@app/modules/activity/enums/payment-status.enum';
import { RelationRelationCreateModalComponent } from '@app/modules/relation-relation/components/relation-activity-create-modal/relation-relation-create-modal.component';
import { RelationRelationTableItemModel } from '@app/modules/relation-relation/models/relation-relation-table.model';

import { RelationUpdateModel } from '@app/modules/relation/models';
import {
    ActivityAvailableParticipantsLabels,
} from '@app/shared/enums/activity-available-participants.enum';
import { ApplicationType } from '@app/shared/enums/application-type.enum';
import { ClaimTypes, ClaimValues } from '@app/shared/models/common/constants';
import { KeyValueModel } from '@app/shared/models/common/key-value.model';
import { TableStateModel } from '@app/shared/models/table/table-state.model';
import { NzModalService } from 'ng-zorro-antd/modal';
import { filter, Observable } from 'rxjs';

@Component({
    selector: 'app-relation-relation-overview',
    templateUrl: './relation-relation-overview.component.html',
    styleUrls: ['./relation-relation-overview.component.less'],
})
export class RelationRelationTableComponent {
    @Input({ required: true }) data: TableStateModel<RelationRelationTableItemModel>;

    @Input({ required: true }) relations$: Observable<KeyValueModel[]>;
    @Input({ required: true }) relation: RelationUpdateModel;

    @Input({ required: true }) loading$: Observable<boolean>;
    @Input({ required: true }) errors$: Observable<{ [key: string]: string[] }>;

   
    @Output() search = new EventEmitter<{ searchQuery: string; skipCount: number }>();
    @Output() create = new EventEmitter<void>();
    @Output() delete = new EventEmitter<number>();

    @Output() resetOverview = new EventEmitter<void>();

    destroyRef = inject(DestroyRef);

    inData: TableStateModel<RelationRelationTableItemModel>;

    constructor(private readonly modalService: NzModalService) {}

    participantStatusMapping = ParticipantStatusLabels;
    participantActivityStatus = ParticipantStatus;

    paymentStatusMapping = PaymentStatusIcons;
    paymentActivityStatus = PaymentStatus;

    applicationType = ApplicationType;
    ActivityAvailableParticipantsMapping = ActivityAvailableParticipantsLabels;

    ClaimTypes = ClaimTypes;
    ClaimValues = ClaimValues;
    draggingEnabled = false;
    nubmers: number[] = [];

    createActivityRelation(relationRelationData?: ActivityRelationUpdateModel) {
        const displayName = `${this.relation.id} ${this.relation.firstName} ${this.relation.middleName ?this.relation.middleName  + " ": ""}${this.relation.lastName}`
        const modal = this.modalService.create({
            nzContent: RelationRelationCreateModalComponent,
            nzWidth: '60%',
            nzMaskClosable: false,
            nzData: {
                relations$: this.relations$,
                relationName: displayName,
                relationId: this.relation.id,
                errors$: this.errors$,
                searchEmitter: this.search,
                createEmitter: this.create,
                relationRelation: relationRelationData,
            },
            nzOnOk: () =>
                new Promise((resolve, reject) => {
                    this.loading$
                        .pipe(
                            takeUntilDestroyed(this.destroyRef),
                            filter((v) => !v),
                        )
                        .subscribe(() => {
                            this.errors$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((error) => {
                                Object.keys(error).length === 0 ? resolve('success') : reject('error');
                            });
                        });
                }),
        });
        modal.afterClose.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.resetOverview.emit());
    }
}
